// extracted by mini-css-extract-plugin
export default {"buttongroup":"ButtonGroup_buttongroup__pHV6k","expandobutton":"ButtonGroup_expandobutton__wAlWv"};